import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

const Horizontal = styled(Box)(({ theme, reverse}) => ({
  display: "flex",
  gap: theme.spacing(2),
  flexDirection: reverse ? "column-reverse" : "column",

  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
  },

  "& > *": {
    flex: 1,
    minWidth: 0
  }
}));

export default Horizontal;
